import type { IndicatorKey } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/IndicatorKey.ts";
import { useTranslation } from "react-i18next";
import type { PeriodSummary } from "@/pages/human-resources/time-management/business/analysis/PeriodSummary.ts";
import useFormatDurationMinutes from "@/pages/human-resources/time-management/model/useFormatDurationMinutes.ts";
import { formatNumber } from "@/shared/utils/Numbers.tsx";

interface IndicatorParts {
  bigPart?: string;
  smallPart?: string;
}

export default function useIndicatorParts(
  summary: PeriodSummary,
  indic: IndicatorKey,
): IndicatorParts {
  const { t } = useTranslation("common");
  const formatDuration = useFormatDurationMinutes();

  const integrals: IndicatorKey[] = [
    "headcount",
    "totalCovers",
    "totalTickets",
    "laborRatio",
    "productivityPerHour",
    "productivityPerPerson",
  ];
  const minutes: IndicatorKey[] = ["workedTimeMinutes"];

  const value = summary[indic];
  let bigPart = undefined;
  let smallPart = undefined;

  if (value !== undefined) {
    if (minutes.includes(indic)) {
      bigPart = formatDuration(value);
    } else {
      if (integrals.includes(indic)) {
        bigPart = formatNumber(t, Math.round(value), 0);
      } else {
        const str = formatNumber(t, value, 2);
        bigPart = str.substring(0, str.length - 3);
        smallPart = str.substring(str.length - 3);
      }
    }
  }
  return { bigPart, smallPart };
}
